import React from 'react';
import { connect } from 'react-redux';
import { Route, Switch, Redirect } from 'react-router-dom';
import './App.scss';

import PasswordRecovery from "../../views/PasswordRecovery/PasswordRecovery";
import PasswordReset from '../../views/PasswordReset/PasswordReset';
import CreateLogin from "../../views/CreateLogin/CreateLogin";
import Login from '../../views/Login/Login';
import Home from '../../containers/Home/Home';

/**
 * @class
 *
 * The root component for app (but not the entry point -- that would  be `index.js`).
 *
 * Here we have our first tier of nesting routing: we separate the protected portion of the app from unauthenticated users,
 * and redirect them to login, create password, or reset password pages.
 */
const App = (props) => {
    // if user is logged in, show protected pages, otherwise show login/password recovery pages:
    return (
        <Switch>
            <Route path='/login/password_recovery' exact component={PasswordRecovery} />
            <Route path='/reset/:token/:id' exact component={PasswordReset} />
            <Route path='/login/create_login' exact component={CreateLogin} />
            <Route path='/login' exact component={Login} />
            {/* n.b. the root path (`/`) doesn't have the `exact` match attribute -- we use it as a default route: */}
            <Route path='/' render={() => (
                props.isLoggedIn
                    ?
                    <Home />
                    :
                    <Redirect to="/login" />
            )}/>
        </Switch>
    );
};


// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        isLoggedIn: state.isLoggedIn
    };
};

export default connect(mapStateToProps)(App);
